// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2l9QR","tab":"Tabs_tab__bJ_fz","tabActive":"Tabs_tabActive__1f_-R"};